import { createContext, useContext } from "react";

import type { AuthUser, OnboardingRequest, OrgSummary } from "@pakker/shared";

type AuthStatus = "loading" | "anonymous" | "authenticated";

export interface AuthState {
  readonly status: AuthStatus;
  readonly user: AuthUser | null;
  readonly organization: OrgSummary | null;
  refresh(): Promise<void>;
  requestMagicLink(email: string): Promise<void>;
  verifyMagicLink(token: string): Promise<AuthUser>;
  completeOnboarding(input: OnboardingRequest): Promise<void>;
  setUnitSystemOverride(value: "metric" | "imperial" | null): Promise<void>;
  endLocalSession(): void;
  logout(): Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error("useAuth must be rendered inside AuthProvider.");
  }
  return context;
}
